<template>
  <div class="right-content-section">
    <div
      v-for="(person, index) in allDetailedTeamMembers"
      :key="person.id"
      :class="['person-card', { 'reverse-order': index % 2 !== 0 }]"
    >
      <template v-if="index % 2 === 0">
        <div class="person-img-container">
          <img :src="getImagePath(person.image)" :alt="person.name" /> 
                </div>
        <div class="person-text-content">
          <h2>{{ person.name }}</h2>
          <h3 >{{ person.category }}</h3>
          <section class="person-description">
            <p v-if="currentLocaleParagraphs(person, 0)">
              {{ currentLocaleParagraphs(person, 0) }}
            </p>
            <p v-if="currentLocaleParagraphs(person, 1)">
              {{ currentLocaleParagraphs(person, 1) }}
            </p>
          </section>
          <router-link :to="{ name: 'TeamDetail', params: { id: person.id } }" class="read-more-link">
            {{ $t('common.readMore') }}
          </router-link>
        </div>
      </template>
      <template v-else>
        <div class="person-text-content">
          <h2>{{ person.name }}</h2>
          <h3 >{{ person.category }}</h3>
          <section class="person-description">
            <p v-if="currentLocaleParagraphs(person, 0)">
              {{ currentLocaleParagraphs(person, 0) }}
            </p>
            <p v-if="currentLocaleParagraphs(person, 1)">
              {{ currentLocaleParagraphs(person, 1) }}
            </p>
          </section>
          <router-link :to="{ name: 'TeamDetail', params: { id: person.id } }" class="read-more-link">
            {{ $t('common.readMore') }}
          </router-link>
        </div>
        <div class="person-img-container">
          <img :src="getImagePath(person.image)" :alt="person.name" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { teamMembers } from '@/data/team';

export default {
  name: 'TeamSection',
  data() {
    return {
      teamData: teamMembers // This holds all partners and associates
    };
  },
  computed: {
    // No longer filtering into separate 'partners' and 'associates' for the loop
    // Combine them directly into a single ordered list
    allDetailedTeamMembers() {
      // You might want to define a specific order here, e.g., partners first, then associates.
      // Assuming 'teamMembers' from '@/data/team' is already ordered as desired.
      return this.teamData;
    }
  },
  methods: {
    currentLocaleParagraphs(person, index) {
      const paragraphs = this.$i18n.locale === 'ro' ? person.paragraphs_ro : person.paragraphs;
      return paragraphs ? paragraphs[index] : '';
    },
    getImagePath(imageName) {
      try {
        return require(`@/assets/contact/lead/${imageName}`);
      } catch (e) {
        console.warn(`Image not found: ${imageName} in src/assets/contact/lead/`, e);
        return ''; // Fallback image or empty string
      }
    }
  }
};
</script>
<style scoped>
/* All existing styles remain the same for default (large screen) layout */

.person-card {
  display: flex; /* Default is row layout */
  align-items: center;
  margin-bottom: 50px;
  background-color: #fdfdfd;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  width: 90%;
  margin-left: 0; /* Changed from auto to 0 to match your current code */
  margin-right: auto;
}

.person-card h3{
font-style: italic; 
color: gray; 
font-weight: 200;
}
/* Specific styling for image container based on its position */
.person-card .person-img-container {
  border-radius: 10px 0 0 10px; /* Default: image on left, rounded left corners */
}

.person-card.reverse-order .person-img-container {
  border-radius: 0 10px 10px 0; /* Reversed: image on right, rounded right corners */
}

/* The rest of your styles are unchanged and should work with this new structure */
.person-img-container {
  flex-shrink: 0;
  width: 450px;
  height: 450px;
  overflow: hidden;
}

.person-img-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
}

.person-text-content {
  flex-grow: 1;
  padding: 30px;
}

.person-text-content h2 {
  font-size: 2rem;
  color: #333;
  margin-top: 0;
  margin-bottom: 15px;
}

.person-description p {
  font-size: 1rem;
  line-height: 1.7;
  color: #666;
}

.read-more-link {
  background-color: #bbd55a;
  color: #0d1a26;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 300;
  text-decoration: none;
  margin-top: 15px;
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: inline-block;
}

.read-more-link:hover {
  background-color: #bbd55a;
  transform: translateY(-2px);
}

.read-more-link:active {
  background-color: #bbd55a;
  transform: translateY(0);
}


/* Media query for screens up to 1700px wide */
@media (max-width: 1700px) {
  .person-card {
    flex-direction: column; /* Force column layout for ALL cards */
    width: 95%;
  }

  /*
   * Crucial change: Explicitly set order for both image and text containers
   * to ensure image is always first in a column layout,
   * regardless of the 'reverse-order' class from the template.
   */
  .person-card .person-img-container,
  .person-card.reverse-order .person-img-container {
    order: -1; /* Always force image to the very top (first in column) */
    border-radius: 10px 10px 0 0; /* Image always on top, rounded top corners */
  }

  .person-card .person-text-content,
  .person-card.reverse-order .person-text-content {
    order: unset; /* Let text content follow the image */
  }

  .person-img-container {
    width: 350px; /* Image takes full width of the card */
    height: 350px; /* Adjust height for column layout */
  }
  
  .person-text-content {
    padding: 20px;
     text-align: justify;
  text-justify: inter-word;
  }
  .person-text-content h2 {
    font-size: 1.8rem;
  }
  .person-description p {
    font-size: 0.95rem;
  }
}

/* Media query for screens up to 768px wide (mobile) */
@media (max-width: 768px) {
   .person-card {
    flex-direction: column; /* Force column layout for ALL cards */
    width: 355px;
  }
  .person-card {
    width: 100%;
    margin-bottom: 30px;
  }
  .person-img-container {
    height: 350px; /* Smaller image height for mobile */
  }
  .person-text-content h2 {
    font-size: 1.4rem;
  }
  .person-description p {
    font-size: 0.85rem;
  }
  .person-card h3{
font-style: italic; 
color: gray; 
font-weight: 200;
font-size:16px;
}

}

/* Media query for very small mobile screens up to 480px wide */
@media (max-width: 480px) {
  .person-text-content h2 {
    font-size: 1.2rem;
  }
  .person-description p {
    font-size: 0.8rem;
  }

    .person-card h3{
font-style: italic; 
color: gray; 
font-weight: 200;
font-size:16px;
}
}
</style>